/**
 * Convert canonical mono Float32 samples to little-endian signed PCM16 bytes.
 *
 * The input is clipped to [-1, 1]. Negative samples use the full -32768 endpoint,
 * positive samples use +32767, and the scaled value is truncated toward zero. In
 * particular, an exact half-LSB tie discards its fractional part toward zero. NaN
 * is treated as silence; infinities clip to the corresponding endpoint. These are
 * deliberate wire-format decisions, not DataView's implicit ToInt16 coercion.
 */
export function canonicalFloat32ToPcm16(samples) {
  const output = new ArrayBuffer(samples.length * 2);
  const view = new DataView(output);
  for (let i = 0; i < samples.length; i += 1) {
    const value = samples[i];
    const finite = Number.isNaN(value) ? 0 : value;
    const clipped = Math.max(-1, Math.min(1, finite));
    const scaled = clipped < 0 ? clipped * 0x8000 : clipped * 0x7fff;
    const quantized = Math.trunc(scaled);
    view.setInt16(i * 2, quantized, true);
  }
  return output;
}
